import tw from "twin.macro";


export const CategoriesSection = tw.div`relative h-[113.437rem] py-[12.5rem] bg-[#0E1222] flex justify-between flex-col overflow-hidden` 
